import { SET_SELECTED_ROOM_KEY } from 'actions';
import { RoomKey } from 'typings';

export function setSelectedRoomKey(selectedRoomKey?: RoomKey) {
  return { selectedRoomKey, type: SET_SELECTED_ROOM_KEY };
}
